const TONE_COLORS = {
  success: "text-forest",
  danger: "text-[color:var(--overdue)]",
  warn: "text-[color:var(--pending)]",
  default: "text-ink",
};

export default function KPICard({ label, value, sub, tone = "default", testid }) {
  const toneColor = TONE_COLORS[tone] || TONE_COLORS.default;
  return (
    <div
      className="border border-line bg-card p-4 sm:p-5 flex flex-col justify-between min-h-[104px] sm:min-h-[120px] transition-colors hover:bg-white"
      data-testid={testid}
    >
      <div className="eyebrow leading-tight">{label}</div>
      <div className={`tabular font-semibold text-lg sm:text-2xl md:text-[26px] tracking-tight mt-2 sm:mt-3 truncate ${toneColor}`}>
        {value}
      </div>
      {sub && <div className="text-[11px] text-ink-2 mt-1.5 sm:mt-2 truncate">{sub}</div>}
    </div>
  );
}
